// Single source of truth for browser-storage key strings.
// Values MUST match the literals already in use — this module is for a later
// migration that swaps the literals for these constants without behaviour change.

export const STORAGE_KEYS = {
  /** localStorage — JSON of the cached user summary object. */
  USER: 'user',
  /** localStorage — JWT session token (sent as the `token` request header). */
  TOKEN: 'token',
  /** localStorage — JSON of the full user profile (Profile page cache). */
  FULL_USER: 'fullUser',
  /** localStorage — society config cache `{ config, timestamp }`, 3h TTL. */
  SOCIETY_CONFIG: 'society_config_cache',
  /** localStorage — homepage products cache (ProductAPI, `HOMEPAGE_CACHE_KEY`). */
  HOMEPAGE_PRODUCTS: 'homepage_products_cache_v3',
  /** sessionStorage — pending deep-link `{ path, applied }` re-applied once on cold start. */
  PENDING_DEEP_LINK: 'pendingDeepLink',
} as const;

/** sessionStorage key for a per-path deep-link extra payload, e.g. `deeplink:/approval`. */
export const deepLinkKey = (path: string): string => `deeplink:${path}`;
